<template>
  <b-card title="Company Information">
    <dl class="row mb-0">
      <dt class="col-sm-3 text-muted mb-50">
        Company Name:
      </dt>
      <dd class="col-sm-9 mb-1 text-break">
        {{ companyName || ($store.state.auth.metadataLoaded ? 'Unavailable' : 'Loading...') }}
      </dd>

      <dt class="col-sm-3 text-muted mb-50">
        FCA Number:
      </dt>
      <dd class="col-sm-9 mb-1 text-break">
        {{ fcaNumber || 'Not provided' }}
      </dd>

      <dt class="col-sm-3 text-muted mb-50">
        Company Address:
      </dt>
      <dd class="col-sm-9 mb-1 text-break company-address">
        {{ companyAddress || 'Not provided' }}
      </dd>

      <dt class="col-sm-3 text-muted mb-50 mb-sm-0">
        Status:
      </dt>
      <dd class="col-sm-9 mb-0">
        <span
          v-if="!$store.state.auth.metadataLoaded"
          role="status"
        >
          Loading subscription status...
        </span>
        <b-badge
          v-else
          pill
          :variant="subscription.variant"
        >
          {{ subscription.label }}
        </b-badge>
      </dd>
    </dl>
  </b-card>
</template>

<script>
import { BBadge, BCard } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BBadge,
    BCard,
  },
  props: {
    fcaNumber: {
      type: [String, Number],
      default: '',
    },
    companyAddress: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('auth', ['isPremium']),
    companyName() {
      return this.$store.state.auth.user.companyname
    },
    subscription() {
      return this.isPremium
        ? { label: 'Premium', variant: 'light-success' }
        : { label: 'Standard', variant: 'light-secondary' }
    },
  },
}
</script>

<style scoped>
.company-address {
  white-space: pre-line;
}
</style>
